export default "__VITE_ASSET__gyXM5Pj0__"